/**
 * Main application component
 *
 * Sets up routing with the AppShell layout and all page routes.
 */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HierarchyProvider } from './context/HierarchyContext';
import { AppShell } from './components/layout/AppShell';
import { WelcomePage } from './components/pages/Welcome';
import { ClientsPage } from './components/pages/Clients';
import { MattersPage } from './components/pages/Matters';
import { ProjectsPage } from './components/pages/Projects';
import { LexisNexisPage } from './components/pages/LexisNexis';
import { BrandwatchPage } from './components/pages/Brandwatch';
import { ModelsPage } from './components/pages/Models';
import { VectorizePage } from './components/pages/Vectorize';
import { AirTrafficControlPage } from './components/pages/AirTrafficControl';
import { UserManagementPage } from './components/pages/UserManagement';
import { MonitoringPage } from './components/pages/Monitoring';

export const App: React.FC = () => {
  return (
    <HierarchyProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/matters" element={<MattersPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/lexisnexis" element={<LexisNexisPage />} />
            <Route path="/brandwatch" element={<BrandwatchPage />} />
            <Route path="/models" element={<ModelsPage />} />
            <Route path="/vectorize" element={<VectorizePage />} />
            <Route path="/atc" element={<AirTrafficControlPage />} />
            <Route path="/users" element={<UserManagementPage />} />
            <Route path="/monitoring" element={<MonitoringPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HierarchyProvider>
  );
};
